import { Icon } from '@unite-us/ui';
import React from 'react';
export var MissingNpiErrorMessage = function MissingNpiErrorMessage() {
  return /*#__PURE__*/React.createElement("div", {
    className: "flex items-center my-2"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "IconExclamationCircle",
    className: "fill-current text-red mr-1"
  }), /*#__PURE__*/React.createElement("p", null, "NCTracks could not verify this record because the organization associated with the user that added it is not a Healthy Opportunities Pilot entity."));
};
//# sourceMappingURL=MissingNpiErrorMessage.js.map